module.exports = __webpack_public_path__ + "static/img/ci.7c073cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem-life-science/ci.png
// module id = 9q1Q
// module chunks = 0